/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MaintenanceRequestResponse = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'string',
    isRequired: true,
},
        details: {
    type: 'string',
    isRequired: true,
},
        assignee: {
    type: 'Assignee',
    isNullable: true,
},
        status: {
    type: 'number',
    isRequired: true,
},
        deadline: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        location: {
    type: 'string',
    isNullable: true,
},
        completionComment: {
    type: 'string',
    isNullable: true,
},
        file: {
    type: 'string',
},
        completionFile: {
    type: 'string',
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        completedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};